import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { withStyles } from '@mui/styles';
import AppAnimate from '../../components/AppAnimate';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { defaultVariables } from '../../../config';
import ItemsSkeleton from '../../components/loaders/ItemsSkeleton';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import {CircularProgress, Divider} from '@mui/material';
import Title from '../../components/elements/Title';
import { scrollTop } from '../../../config/values';
import NothingFound from "../../components/elements/NothingFound";
import {ChevronLeft, ClipboardList, RefreshCw} from "lucide-react";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import SingleOrderItem from "./SingleOrderItem";
import SubTitle from "../../components/elements/SubTitle";
import MyWallet from "../../components/elements/MyWallet";
import ListFilters from "../manage/lists/filters/ListFilters";

function OrdersPage({ role }) {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [filters, setFilters] = useState({});
    const [activeOrders, setActiveOrders] = useState([]);
    const [pastOrders, setPastOrders] = useState([]);
    const [pastOrdersPage, setPastOrdersPage] = useState(1);
    const [hasMorePastOrders, setHasMorePastOrders] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };

    const loadData = async (type, page = 1, append = false) => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${defaultVariables.url}/orders/get-all/${role}?is_active=${type}&page=${page}${!!filters.shop_id ? "&shop_id="+filters.shop_id : ""}${!!filters.date ? "&date="+filters.date : ""}${!!filters.text ? "&search="+filters.text : ""}${!!filters.industry ? "&industry="+filters.industry : ""}`,
                config
            );
            if (type === 'active') {
                setActiveOrders(response.data.data);
            } else {
                setPastOrders((prev) => append ? [...prev, ...response.data.data] : response.data.data);
                setHasMorePastOrders(response.data.data.length > 0);
            }
        } catch (error) {
            enqueueSnackbar('Error fetching orders. Please try again.', { variant: 'error' });
            console.log(error.response)
        } finally {
            setLoading(false);
            setInitialLoad(false);

        }
    };

    useEffect(() => {
        scrollTop();
        loadData('active');
        loadData('past');
    }, []);

    useEffect(() => {
        scrollTop();
        loadData('active');
        loadData('past');
    },[filters]);

    const handleFilter = (filters) => {
        setFilters(filters);
        //setInitialLoad(true);
    }
    const loadMorePastOrders = () => {
        if (!loading && hasMorePastOrders) {
            const nextPage = pastOrdersPage + 1;
            setPastOrdersPage(nextPage);
            loadData('past', nextPage, true);
        }
    };
    const handleRefresh = () => {
        setPastOrdersPage(1);
        setHasMorePastOrders(true);
        setInitialLoad(true);
        loadData('active');
        loadData('past');
    };
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('orders')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={12} className="flex-space">
                    {
                        role !== 'admin' &&
                        <>
                            <Title align="left" color="text" className="panel-title">
                                {t('orders')}
                                <Button
                                    size="small"
                                    color="primary"
                                    startIcon={<RefreshCw />}
                                    onClick={handleRefresh}
                                    disabled={loading}
                                    style={{marginLeft:5}}
                                >
                                    {t('refresh')}
                                </Button>
                            </Title>

                            <MyWallet/>
                        </>
                    }

                </Grid>
                {
                    (role === "admin" || role === "transport" || role === "supplier" || role === "user") &&
                    <Grid item size={12}>
                        <ListFilters
                            filters={ role === "supplier" ? ['search','time'] : role === "admin" ? ['search', 'industries', 'all', 'shops' ,'time'] : ['search', 'industries', 'all']}
                            onFilter={handleFilter}
                        />
                    </Grid>
                }
                {
                    initialLoad ? <ItemsSkeleton lg={6} height={320}/> : (
                        <>
                            {
                                !!activeOrders.length &&
                                <Grid item size={12}>
                                    <SubTitle variant="h6" className="dialog-title mb-20" align="left">{t('activeOrders')}</SubTitle>
                                    <Grid container spacing={2}>
                                        {activeOrders.map((order, index) => (
                                            <Grid item size={{xs:12,md:6}} key={order.id}>
                                                <SingleOrderItem order={order} role={role}/>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            }
                            {
                                !!pastOrders.length &&

                                <Grid item size={12}>
                                    <Divider className="my-20"/>

                                    <SubTitle variant="h6" className="dialog-title mb-20" align="left">{t('pastOrders')}</SubTitle>
                                    <InfiniteScroll
                                        dataLength={pastOrders.length}
                                        next={loadMorePastOrders}
                                        hasMore={hasMorePastOrders}
                                        loader={(
                                            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                                {loading && <CircularProgress />}
                                            </div>
                                        )}
                                    >
                                        <Grid container spacing={2}>
                                            {pastOrders.map((order, index) => (
                                                <Grid item size={{xs:12,md:6}} key={index}>
                                                    <SingleOrderItem order={order} role={role}/>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </InfiniteScroll>
                                </Grid>
                            }
                            <Grid item size={12} style={{backgroundColor:"#f5f5f5", borderRadius:16}}>
                            {!initialLoad && pastOrders.length === 0 && activeOrders.length === 0 && !hasMorePastOrders && (
                                <NothingFound
                                    type="page"
                                    title={t('noOrderFound')}
                                    title_color="text"
                                    paragraph={role === "user" ? t('noOrderFoundDecUser') : t('noOrderFoundDec')}
                                    icon={<ClipboardList/>}
                                >
                                    <Button
                                        variant="outlined"
                                        startIcon={<ChevronLeft/>}
                                        component={Link}
                                        to={`/`}
                                    >
                                        {t('back')}
                                    </Button>
                                </NothingFound>
                            )}
                            </Grid>
                        </>
                    )
                }
            </Grid>
        </AppAnimate>
    );
}

export default withStyles({})(OrdersPage);
